import React, { useState } from "react";
import emailjs from "emailjs-com";
import img1 from "../../Assets/Contact/location.png";
import img2 from "../../Assets/Contact/email.png";
import img3 from "../../Assets/Contact/telephone.png";
import name from "../../Assets/Contact/name.png";
import email from "../../Assets/Contact/formEmail.png";
import phone from "../../Assets/Contact/phone.png";
import message from "../../Assets/Contact/message.png";
import departureCity from "../../Assets/Contact/departureCity.png";
import calender from "../../Assets/Contact/calender.png";
import children from "../../Assets/Contact/children.png";
import adult from "../../Assets/Contact/adult.png";

const StayConnected = () => {
  const [formValues, setFormValues] = useState({
    name: "",
    email: "",
    phone: "",
    message: "",
  });

  const [errors, setErrors] = useState({});
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [successMessage, setSuccessMessage] = useState("");

  const handleChange = (e) => {
    const { id, value } = e.target;
    setFormValues({ ...formValues, [id]: value });
  };

  const validate = () => {
    const newErrors = {};
    if (!formValues.name) newErrors.name = "Name is required";
    if (!formValues.email) {
      newErrors.email = "Email is required";
    } else if (!/\S+@\S+\.\S+/.test(formValues.email)) {
      newErrors.email = "Email address is invalid";
    }
    if (!formValues.phone) {
      newErrors.phone = "Phone number is required";
    } else if (!/^\d{10}$/.test(formValues.phone)) {
      newErrors.phone = "Phone number must be 10 digits";
    }
    if (!formValues.message) newErrors.message = "Message is required";
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (validate()) {
      setIsSubmitting(true);

      // Sending email with EmailJS
      const formattedData = {
        name: formValues.name,
        email: formValues.email,
        phone: formValues.phone,
        message: formValues.message,
        departureCity: formValues.departureCity,
        date: formValues.date,
        children: formValues.children,
        adults: formValues.adults,
      };

      console.log("Formatted Data:", formattedData);

      // Sending email with EmailJS
      emailjs
        .send(
          "service_qda9r1p",
          "template_woapl0d",
          formattedData, // Send the consolidated object
          "NcGgN4drK0cL1rQnO"
        )
        .then((response) => {
          console.log("SUCCESS!", response.status, response.text);
          setSuccessMessage("Message sent successfully!");
          setFormValues({
            name: "",
            email: "",
            phone: "",
            message: "",
            departureCity: "",
            date: "",
            children: "",
            adults: "",
          });
          setErrors({});
        })
        .catch((error) => {
          console.error("FAILED...", error);
          setErrors({ form: "Failed to send message, please try again." });
        })
        .finally(() => {
          setIsSubmitting(false);
        });
    }
  };
  // function DateFieldWithPlaceholder() {
  //   const [inputType, setInputType] = useState("text");
  //   const [date, setDate] = useState("");

  //   const handleFocus = () => {
  //     setInputType("date");
  //   };

  //   const handleBlur = () => {
  //     if (!date) {
  //       setInputType("text"); // Revert to text if no date is selected
  //     }
  //   };

  //   return (
  //     <input
  //       type={inputType}
  //       value={date}
  //       onChange={(e) => setDate(e.target.value)}
  //       onFocus={handleFocus}
  //       onBlur={handleBlur}
  //       id="date"
  //       className="w-full p-2 pl-8 lg:pl-4 xl:pl-8 xl-pl-8 border border-l-[#949292] outline-none opacity-80 "
  //       placeholder="Departure Date"
  //     />
  //   );
  // }

  return (
    <div className="mx-4 my-6 sm:mx-6 sm:my-8 lg:mx-16">
      <div className="flex flex-col items-center">
        <h1
          style={{ fontFamily: "DM Sans, sans-serif" }}
          className="text-3xl sm:text-4xl font-bold text-center text-[#292929] tracking-wide "
        >
          Stay Connected
        </h1>
        <p
          style={{ fontFamily: "'Figtree', sans-serif" }}
          className="my-4 w-full text-center text-base text-[#595959] sm:max-w-2xl"
        >
          We’d love to hear from you! Whether you're looking to book an
          appointment or have questions about our services, feel free to reach
          out to us.
        </p>
      </div>

      <div className="flex min-w-0 flex-col lg:flex-row">
        {/* Contact Details Section */}
        <div className="w-full rounded-md bg-[#E9B301] p-5 text-white sm:p-8 lg:w-2/5 lg:py-12 xl:py-16" data-aos="fade-down">
          <div className="mb-8 flex min-w-0 flex-col items-start gap-3 sm:flex-row sm:gap-5 lg:items-center">
            <img src={img1} alt="" className="h-8 w-8 shrink-0 object-contain" />
            <div className="flex flex-col">
              <h1
                style={{ fontFamily: "Lato, sans-serif" }}
                className="font-bold text-lg md:text-xl "
              >
                Address
              </h1>
              <p
                className="mt-2 break-words text-sm leading-relaxed opacity-80"
                style={{ fontFamily: "Poppins, sans-serif" }}
              >
                Gpo, Plot No 298, Unit-6, Biju Patnaik International
                Airport-Aerodrome, Ekamra Rd, Ganga Nagar, Bhubaneswar, Odisha
                751020
              </p>
            </div>
          </div>

          <div className="mb-8 flex min-w-0 flex-col items-start gap-3 sm:flex-row sm:gap-5 lg:items-center">
            <img src={img2} alt="" className="h-8 w-8 shrink-0 object-contain" />
            <div className="flex flex-col">
              <h1
                style={{ fontFamily: "Lato, sans-serif" }}
                className="font-bold text-lg md:text-xl "
              >
                Email
              </h1>
              <p
                className="mt-2 break-all text-sm leading-relaxed opacity-80"
                style={{ fontFamily: "Poppins, sans-serif" }}
              >
                rameshbarad264@gmail.com
              </p>
            </div>
          </div>

          <div className="flex min-w-0 flex-col items-start gap-3 sm:flex-row sm:gap-5 lg:items-center">
            <img src={img3} alt="" className="h-8 w-8 shrink-0 object-contain" />
            <div className="flex flex-col">
              <h1
                style={{ fontFamily: "Lato, sans-serif" }}
                className="font-bold text-lg md:text-xl "
              >
                Phone
              </h1>
              <p
                className="mt-2 text-sm leading-relaxed opacity-80 cursor-pointer"
                style={{ fontFamily: "Poppins, sans-serif" }}
              >
                <a href="tel:+918249686752" >
              +91 824 968 6752
            </a>
              </p>
            </div>
          </div>
        </div>

        {/* Contact Form Section */}
        <div className="w-full min-w-0 rounded-md bg-orange-50 p-4 sm:p-6 lg:w-3/5 lg:p-10 xl:p-12" data-aos="fade-left">
          <h2
            style={{ fontFamily: "DM Sans, sans-serif" }}
            className="text-2xl sm:text-3xl font-bold mb-6 md:mb-8 tracking-wide "
          >
            Get In Touch
          </h2>
          {successMessage && (
            <p className="text-green-500 text-sm mb-4">{successMessage}</p>
          )}
          {errors.form && (
            <p className="text-red-500 text-sm mb-4">{errors.form}</p>
          )}
          <form onSubmit={handleSubmit}>
            <div className="mb-5 flex min-w-0 flex-wrap border border-[#949292]">
              <img src={name} alt="" className="w-12 shrink-0 bg-white p-3 sm:w-14 sm:p-4" />
              <input
                className="min-w-0 flex-1 border border-l-[#949292] p-2 pl-3 outline-none opacity-80 sm:pl-4"
                type="text"
                id="name"
                placeholder="Name"
                value={formValues.name}
                onChange={handleChange}
              />
              {errors.name && (
                <p className="basis-full px-3 pb-2 text-sm text-red-500">{errors.name}</p>
              )}
            </div>
            <div className="mb-5 flex min-w-0 flex-wrap border border-[#949292]">
              <img src={email} alt="" className="w-12 shrink-0 bg-white p-3 sm:w-14 sm:p-4" />
              <input
                className="min-w-0 flex-1 border border-l-[#949292] p-2 pl-3 outline-none opacity-80 sm:pl-4"
                type="email"
                id="email"
                placeholder="Email"
                value={formValues.email}
                onChange={handleChange}
              />
              {errors.email && (
                <p className="basis-full px-3 pb-2 text-sm text-red-500">{errors.email}</p>
              )}
            </div>
            <div className="mb-5 flex min-w-0 flex-wrap border border-[#949292]">
              <img src={phone} alt="" className="w-12 shrink-0 bg-white p-3 sm:w-14 sm:p-4" />
              <input
                className="min-w-0 flex-1 border border-l-[#949292] p-2 pl-3 outline-none opacity-80 sm:pl-4"
                type="text"
                id="phone"
                placeholder="Phone"
                value={formValues.phone}
                onChange={handleChange}
              />
              {errors.phone && (
                <p className="basis-full px-3 pb-2 text-sm text-red-500">{errors.phone}</p>
              )}
            </div>
            <div className="mb-5 flex min-w-0 flex-wrap border border-[#949292]">
              <img src={message} alt="" className="w-12 shrink-0 bg-white p-3 sm:w-14 sm:p-4" />
              <input
                className="min-w-0 flex-1 border border-l-[#949292] p-2 pl-3 outline-none opacity-80 sm:pl-4"
                id="message"
                placeholder="Message"
                value={formValues.message}
                onChange={handleChange}
              ></input>
              {errors.message && (
                <p className="basis-full px-3 pb-2 text-sm text-red-500">{errors.message}</p>
              )}
            </div>

            <div className="grid grid-cols-1 gap-x-4 md:grid-cols-2">
              <div className="mb-5 flex min-w-0 flex-wrap border border-[#949292]">
                <img
                  src={departureCity}
                  alt=""
                  className="w-12 shrink-0 bg-white p-3 opacity-80 sm:w-14 sm:p-4"
                />
                <input
                  className="min-w-0 flex-1 border border-l-[#949292] p-2 pl-3 outline-none opacity-80 sm:pl-4"
                  id="city"
                  placeholder="Departure City"
                  value={formValues.departureCity}
                  onChange={handleChange}
                />

                {errors.message && (
                  <p className="basis-full px-3 pb-2 text-sm text-red-500">{errors.message}</p>
                )}
              </div>

              <div className="mb-5 flex min-w-0 flex-wrap border border-[#949292]">
                <img
                  src={calender}
                  alt=""
                  className="w-12 shrink-0 bg-white p-3 opacity-80 sm:w-14 sm:p-4"
                />

                <input
                  className="min-w-0 flex-1 border-l-gray-400 p-2 pl-3 outline-none sm:pl-4"
                  type="date"
                  id="date"
                  value={formValues.date}
                  onChange={handleChange}
                />

                {errors.message && (
                  <p className="basis-full px-3 pb-2 text-sm text-red-500">{errors.message}</p>
                )}
              </div>
            </div>

            <div className="grid grid-cols-1 gap-x-4 md:grid-cols-2">
              <div className="mb-5 flex min-w-0 flex-wrap border border-[#949292]">
                <img
                  src={children}
                  alt="no. of children"
                  className="w-12 shrink-0 bg-white p-3 opacity-80 sm:w-14 sm:p-4"
                />
                <input
                  className="min-w-0 flex-1 border border-l-[#949292] p-2 pl-3 outline-none opacity-80 sm:pl-4"
                  id="children"
                  placeholder="No. of Children"
                  value={formValues.children}
                  onChange={handleChange}
                ></input>

                {errors.message && (
                  <p className="basis-full px-3 pb-2 text-sm text-red-500">{errors.message}</p>
                )}
              </div>

              <div className="mb-5 flex min-w-0 flex-wrap border border-[#949292]">
                <img
                  src={adult}
                  alt="no. of adults"
                  className="w-12 shrink-0 bg-white p-3 opacity-80 sm:w-14 sm:p-4"
                />
                <input
                  className="min-w-0 flex-1 border border-l-[#949292] p-2 pl-3 outline-none opacity-80 sm:pl-4"
                  id="children"
                  placeholder="No. of Adults"
                  value={formValues.adults}
                  onChange={handleChange}
                />

                {errors.message && (
                  <p className="basis-full px-3 pb-2 text-sm text-red-500">{errors.message}</p>
                )}
              </div>
            </div>

            <button
              type="submit"
              className="w-full rounded bg-[#FCC101] px-6 py-3 font-medium text-white shadow-xl hover:bg-[#ca9a04] sm:w-auto sm:min-w-40"
              disabled={isSubmitting}
            >
              {isSubmitting ? "Sending..." : "Submit"}
            </button>
          </form>
        </div>
      </div>
    </div>
  );
};

export default StayConnected;
